/***********************************************************/
/***********************************************************/
/* AutoInvest Active Orders Overview Module */
/***********************************************************/
/***********************************************************/

var autoInvestOrdersModule = (function() {

  var url = '/account/autoinvest';
  var cachedShippingCountries = [];
  var cachedShippingData = {};
  var forceShipToDifferentLocation = false;
  var forceShipItems = {}; // Per-item tracking: persists across popup open/close
  var originalShippingData = {}; // Store original data for change detection
  var updateDetailsResponse = {}; // Store update-details response for close popup notification
  var allowApplyToAll = false; // Add this at module level


  function init(options, cb) {
    console.log("Inside init");

    if (typeof options === 'function') {
      cb = options;
      options = {};
    }

    options = options || {};

    var data = {
      locationId: locationId
    };

    console.log("data: ", data);

    var req = new Request(servicesUrl + url + '/init', data);

    req.success(function(res) {
      console.log("Init response:", res);

      if (res.success) {
        cachedShippingCountries = res.shippingCountries || [];
        forceShipToDifferentLocation = res.forceShipToDifferentLocation || false;
        allowApplyToAll = res.allowApplyToAll || false;
        console.log("Updated allowApplyToAll inside init to:", allowApplyToAll);
        typeof cb === 'function' && cb(res);
      } else {
        console.error("Init failed:", res);
        if (typeof cb === 'function') {
          cb({
            success: false,
            error: res.error || 'Failed to initialize auto-invest',
            errorCode: res.errorCode || 'INIT_FAILED'
          });
        }
      }
    });

    req.error(function(res) {
      console.log(res)
    });

    req.call();
  }

  function previewDetails(data, cb) {
    if (typeof data === 'function') {
      cb = data;
      data = {};
    }

    data = data || {};

    var req = new Request(servicesUrl + url + '/preview-details', data);

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
      } else {
        console.error("Preview details failed:", res);
      }
    });

    req.call();
  }

  function previewDetailsPayment(data) {
    data = data || {};
    var req = new Request(servicesUrl + url + '/preview-details-payment', data);
    req.success(function(res) {
      console.log("Preview details payment response:", res);
    });
    req.call();
  }

  function checkEmptyAutoInvestOrders(res) {
    if (!res.items || !res.items.length) {
      var noItem = '<tr class="no-item"><td class="padding-side-10 no-border-bot"></td><td class="no-border-bot empty text-left" colspan="6">You currently have no active AutoInvest orders. To get started, simply add your preferred products to your cart as you would for a regular purchase. At checkout, select your desired AutoInvest frequency and confirm your order.</td><td class="padding-side-10 no-border-bot"></td></tr>';
      $('.autoinvest-orders-table > tbody').html(noItem);
    }
  }

  function buttonActions() {
    document.removeEventListener("click", handleButtonClick);
    document.addEventListener("click", handleButtonClick);
  }

  function handleButtonClick(e) {
    // DROP-DOWN BUTTON
    if (e.target && e.target.closest(".drop-down-button")) {
      console.log("DROP-DOWN BUTTON");

      const button = e.target.closest(".drop-down-button");
      e.preventDefault();
      handleDropDownButton(button);
      return;
    }

    // UPDATE BUTTON
    if (e.target && e.target.id === "btn-update") {
      console.log("UPDATE BUTTON");
      e.preventDefault();
      handleUpdateButton(e.target);
      return;
    }

    // SKIP-NEXT-ORDER BUTTON
    if (e.target && e.target.id === "btn-skip-next-order") {
      console.log("SKIP-NEXT-ORDER BUTTON");
      e.preventDefault();
      handleSkipNextOrder(e.target);
      return;
    }

    // UPDATE-SHIPPING-ADDRESS BUTTON (use class instead of ID)
    if (e.target && e.target.classList.contains("update-shipping-address")) {
      console.log("UPDATE-SHIPPING-ADDRESS BUTTON");
      e.preventDefault();
      handleUpdateShippingAddress(e.target);
      return;
    }

    // CANCEL-AUTO-INVEST BUTTON
    if (e.target && e.target.id === "btn-cancel-auto-invest") {
      console.log("CANCEL-AUTO-INVEST BUTTON");
      e.preventDefault();
      handleCancelAutoInvest(e.target);
      return;
    }
  }

  function handleDropDownButton(button) {
    console.log("DROP-DOWN BUTTON Clicked");
    try {
      const itemId = button.getAttribute("data-item-id");

      if (itemId) {
        const controlsRow = document.querySelector(`#auto-invest-item-${itemId}`);

        if (controlsRow) {
          const isCurrentlyHidden = controlsRow.style.display === 'none';

          if (isCurrentlyHidden) {
            controlsRow.style.display = '';
            // Rotate arrow up (180 degrees)
            button.style.transform = 'rotate(180deg)';
          } else {
            controlsRow.style.display = 'none';
            // Rotate arrow back to original position (0 degrees)
            button.style.transform = 'rotate(0deg)';
          }
        }
      }

    } catch (error) {
      console.error("Drop-down button error:", error);
    }
  }

  function handleUpdateButton(button) {
    console.log("UPDATE BUTTON Clicked");

    try {
      const container = button.closest(".autoinvest-controls-wrapper");
      const row = container.closest("tr").previousElementSibling;

      const itemId = row.getAttribute("data-item-id");
      const productId = row.getAttribute("data-product-id");

      // Get quantity from the data row (previous sibling)
      const quantityInput = row.querySelector("input[name='productQuantity']");
      const quantity = quantityInput?.value;

      const frequency = container.querySelector("select[name='frequency']")?.value;
      const currency = container.querySelector("select[name='currency']")?.value;
      const payment = container.querySelector("select[name='payment']")?.value;
      const delivery = container.querySelector("select[name='delivery']")?.value;

      const data = {
        id: itemId,
        productId: productId,
        frequencyId: frequency,
        currency: currency,
        paymentMethodId: payment,
        shippingMethodId: delivery,
        quantity: quantity,
        locationId: locationId
      };

      console.log("Sending update data:", data);

      const requestUrl = `${servicesUrl}${url}/update-details`;

      var req = new Request(requestUrl, data);

      req.success(function(result) {
        console.log("Update successful:", result);

        // Update allowApplyToAll from the response
        if (result.allowApplyToAll !== undefined && result.allowApplyToAll !== null) {
          allowApplyToAll = result.allowApplyToAll;
          console.log("Updated allowApplyToAll inside update-details to:", allowApplyToAll);
        }

        // Update UI with response data
        if (result.id) {
          const dataRow = document.querySelector(`tr[data-item-id="${result.id}"]`);

          if (dataRow) {
            // Update quantity if returned in response
            if (result.quantity || result.productQuantity) {
              const quantityInput = dataRow.querySelector("input[name='productQuantity']");
              if (quantityInput) {
                quantityInput.value = result.quantity || result.productQuantity;
              }
            }

            // Update other UI elements if they exist in the response
            if (result.nextAutoInvestDateString) {
              const nextOrderDateCell = dataRow.querySelector('.auto-invest-item-next-order-date');
              if (nextOrderDateCell) {
                nextOrderDateCell.textContent = result.nextAutoInvestDateString;
              }
            }

            // Update frequency display if returned
            if (result.frequency || result.frequencyName) {
              const frequencyCell = dataRow.querySelector('.auto-invest-item-frequency');
              if (frequencyCell) {
                frequencyCell.textContent = result.frequency || result.frequencyName;
              }
            }

            // Update currency display if returned
            if (result.currency) {
              const currencyCell = dataRow.querySelector('.auto-invest-item-currency');
              if (currencyCell) {
                currencyCell.textContent = result.currency;
              }
            }

            // Update total amount if returned
            if (result.totalAmount) {
              const totalCell = dataRow.querySelector('.auto-invest-item-total');
              if (totalCell) {
                totalCell.textContent = result.totalAmount;
              }
            }
          }

          // Track per-item forced shipping state so it survives popup close
          forceShipItems[result.id] = result.forceUpdateShippingAddress === true;

          // Show/hide shipping address link based on shipping property
          // This controls the VISIBILITY of the link
          updateShippingAddressLinkVisibility(result.id, result.shipping);

          // Auto-open shipping address popup ONLY if forceUpdateShippingAddress is true
          // This controls the AUTOMATIC OPENING of the popup
          if (result.forceUpdateShippingAddress === true) {
            console.log("Auto-opening shipping address popup due to forceUpdateShippingAddress");

            // NEW: Store the update-details response for later use in handleCloseShippingPopup
            updateDetailsResponse[result.id] = {
              forceUpdateShippingAddress: result.forceUpdateShippingAddress,
              forceUpdateShippingAddressCancelNotificationMessage: result.forceUpdateShippingAddressCancelNotificationMessage,
              title: result.title || 'AutoInvest Update',
              shippingMethodId: result.shippingMethodId || result.deliveryMethodId
            };

            // Update the global forceShipToDifferentLocation flag
            forceShipToDifferentLocation = true;

            // Get shipping details from cache or data attribute
            const itemRow = document.querySelector(`tr[data-item-id="${result.id}"]`);
            let shippingDetails;

            if (cachedShippingData[result.id]) {
              console.log("Using cached shipping data for item:", result.id);
              shippingDetails = cachedShippingData[result.id];
            } else if (itemRow) {
              console.log("Using data attribute for item:", result.id);
              shippingDetails = JSON.parse(itemRow.getAttribute('data-shipping-details') || '{}');
            } else {
              // Fallback to empty object
              shippingDetails = {
                defaultAddress: {},
                shippingToAnotherAddress: {},
                shipToAnother: false
              };
            }

            // Prepare shipping data for popup
            var shippingData = {
              ...shippingDetails,
              title: 'Shipping Address',
              itemId: result.id,
              shippingCountries: cachedShippingCountries,
              forceShipToDifferentLocation: forceShipToDifferentLocation,
              locationId: locationId,
              handleCloseShippingPopup: handleCloseShippingPopup,
              isAutoOpened: true // indicates popup was auto-opened due to forceUpdateShippingAddress
            };

            console.log("Opening shipping popup with data:", shippingData);

            // Store original data before opening popup
            storeOriginalShippingData(result.id, shippingDetails);

            // Open the popup
            var popupAutoInvestShippingAddress = new PopupAutoInvestShippingAddress(shippingData);
            popupAutoInvestShippingAddress.render();

            if (allowApplyToAll) {
              $('.checkbox-one-line.full-width').removeClass('hide');
            } else {
              $('.checkbox-one-line.full-width').addClass('hide');
            }

            // Toggle shipping forms and trigger country change
            toggleShippingForms();
            setTimeout(function() {
              $('#shipping-country').trigger('change');
            }, 100);
          }
        }
      });

      req.error(function(err) {
        console.error("Update error:", err);
      });

      req.call();

    } catch (error) {
      console.error("Update button error:", error);
    }
  }

  function handleSkipNextOrder(button) {
    console.log("SKIP-NEXT-ORDER BUTTON Clicked");

    if (button.disabled || button.classList.contains('disabled')) {
      console.log("Skip button is disabled, ignoring click");
      return;
    }

    try {
      const container = button.closest(".autoinvest-controls-wrapper");

      const row = container.closest("tr").previousElementSibling;

      const itemId = row.getAttribute("data-item-id");

      console.log("Sending skip order with autoInvestId:", itemId);

      const requestUrl = `${servicesUrl}${url}/skip-next-order`;

      const data = {
        autoInvestId: itemId
      };

      var req = new Request(requestUrl, data);

      req.afterWarningDialogFunction(function(res) {
        req.send(true);
      })

      req.afterErrorDialogFunction(function(res) {
        window.location.reload();
      })

      req.success(function(result) {
        console.log("Skip order successful:", result);

        if (result.id) {
          const dataRow = document.querySelector(`tr[data-item-id="${result.id}"]`);

          if (dataRow) {
            const nextOrderDateCell = dataRow.querySelector('.auto-invest-item-next-order-date');
            if (nextOrderDateCell && result.nextAutoInvestDateString) {
              nextOrderDateCell.textContent = result.nextAutoInvestDateString;
            }

            const controlsRow = document.querySelector(`#auto-invest-item-${result.id}`);
            if (controlsRow) {
              const skipButton = controlsRow.querySelector('#btn-skip-next-order');
              if (skipButton) {
                skipButton.classList.add('disabled');
                skipButton.disabled = true;
              }
            }
          }
        }
      });

      req.error(function(err) {
        console.error("Skip order error:", err);
      });

      req.call();

    } catch (error) {
      console.error("Skip order button error:", error);
    }
  }

  function handleUpdateShippingAddress(button) {
    console.log("UPDATE-SHIPPING-ADDRESS BUTTON Clicked");

    try {
      const popup = button.closest('.popup-autoinvest-shipping-address');
      let itemId = originalShippingData.itemId;

      // Fallback logic only if itemId is not found
      if (!itemId) {
        const firstItemRow = document.querySelector('tr[data-item-id]');
        if (firstItemRow) {
          itemId = firstItemRow.getAttribute('data-item-id');
        }
      }

      if (!itemId) {
        console.error("Could not determine itemId for shipping address update");
        return;
      }

      const useDefaultAddress = !forceShipToDifferentLocation && popup.querySelector('#ship-to-same-address')?.checked;
      const useDifferentAddress = forceShipToDifferentLocation || popup.querySelector('#ship-to-another-address')?.checked;

      let shippingData = {};

      if (useDefaultAddress) {
        shippingData = {
          shipToAnother: false,
          autoInvestId: itemId
        };
      } else if (useDifferentAddress) {
        const allFields = popup.querySelectorAll('.shipping-info-field');
        allFields.forEach(field => field.blur());

        const nameValue = popup.querySelector('#shipping-name')?.value?.trim() || '';
        const address1Value = popup.querySelector('#shipping-address1')?.value?.trim() || '';
        const address2Value = popup.querySelector('#shipping-address2')?.value?.trim() || '';
        const cityValue = popup.querySelector('#shipping-city')?.value?.trim() || '';
        const postCodeValue = popup.querySelector('#shipping-post-code')?.value?.trim() || '';

        let stateValue = '';
        const stateTextField = popup.querySelector('#shipping-state-textfield');
        const stateDropdown = popup.querySelector('#shipping-state');
        const stateFormField = popup.querySelector('.state-form-field');
        const stateFormSelectField = popup.querySelector('.state-form-select-field');


        if (stateFormSelectField && !stateFormSelectField.classList.contains('hide') && stateDropdown) {
          stateValue = stateDropdown.value?.trim() || '';
        } else if (stateFormField && !stateFormField.classList.contains('hide') && stateTextField) {
          stateValue = stateTextField.value?.trim() || '';

          if (!stateValue) {
            const dataParam = stateTextField.getAttribute('data-param');
            const inputType = stateTextField.getAttribute('data-input-type');
            console.log("State field is empty, checking data attributes...");
            console.log("data-param:", dataParam);
            console.log("data-input-type:", inputType);

            stateValue = stateTextField.getAttribute('value') ||
              stateTextField.dataset.value ||
              '';
          }

          console.log("Using textfield state value:", stateValue);
        } else {
          stateValue = stateTextField?.value?.trim() || stateDropdown?.value?.trim() || '';
          console.log("Using fallback state value:", stateValue);
        }

        const countryValue = popup.querySelector('#shipping-country')?.value?.trim() || '';

        shippingData = {
          shipToAnother: true,
          autoInvestId: itemId,
          shippingName: nameValue,
          shippingAddress1: address1Value,
          shippingAddress2: address2Value,
          shippingCity: cityValue,
          shippingPostCode: postCodeValue,
          shippingState: stateValue,
          shippingCountryCode: countryValue
        };

      }

      const applyToAll = allowApplyToAll && (popup.querySelector('#apply-to-all-orders')?.checked || false);
      shippingData.applyToAllOrders = applyToAll;

      console.log("Shipping data to send:", shippingData);

      // Validate required fields if shipping to different address
      if (useDifferentAddress) {
        const requiredFields = ['shippingName', 'shippingAddress1', 'shippingCity', 'shippingPostCode', 'shippingCountryCode'];
        const missingFields = [];

        for (let field of requiredFields) {
          if (!shippingData[field] || shippingData[field].trim() === '') {
            missingFields.push(field.replace('shipping', ''));
          }
        }

        if (missingFields.length > 0) {
          console.error("Missing required shipping fields:", missingFields);
          return;
        }
      }

      const requestUrl = `${servicesUrl}${url}/update-shipping-details`;

      var req = new Request(requestUrl, shippingData);

      req.success(function(result) {
        console.log("Shipping address update successful:", result);

        console.log("result.item.autoInvestId " + result.item.autoInvestId);
        console.log("result.shipping " + result.shipping);

        updateShippingAddressLinkVisibility(itemId, result.shipping);

        if (result.success && result.item) {
          console.log("Shipping address updated successfully");

          // Sync allowApplyToAll from response
          if (result.allowApplyToAll !== undefined && result.allowApplyToAll !== null) {
            allowApplyToAll = result.allowApplyToAll;
          }

          // Structured the cached data with correct field names
          const shippingDetails = {
            defaultAddress: result.item.defaultAddress || {},
            shippingToAnotherAddress: {
              name: result.item.shippingToAnotherAddress?.name || shippingData.shippingName || '',
              address1: result.item.shippingToAnotherAddress?.address1 || shippingData.shippingAddress1 || '',
              address2: result.item.shippingToAnotherAddress?.address2 || shippingData.shippingAddress2 || '',
              city: result.item.shippingToAnotherAddress?.city || shippingData.shippingCity || '',
              postCode: result.item.shippingToAnotherAddress?.postCode || shippingData.shippingPostCode || '',
              state: result.item.shippingToAnotherAddress?.state || shippingData.shippingState || '',
              countryCode: result.item.shippingToAnotherAddress?.countryCode || shippingData.shippingCountryCode || ''
            },
            shipToAnother: result.item.shipToAnother !== undefined ? result.item.shipToAnother : shippingData.shipToAnother
          };

          if (applyToAll) {
            // If apply to all, update cache for all items
            const allItemRows = document.querySelectorAll('tr[data-item-id]');
            allItemRows.forEach(row => {
              const id = row.getAttribute('data-item-id');
              cachedShippingData[id] = shippingDetails;

              // Update data-shipping-details attribute
              row.setAttribute('data-shipping-details', JSON.stringify(shippingDetails));
            });
          } else {
            // Update cache for specific item only
            cachedShippingData[itemId] = shippingDetails;

            // Update data-shipping-details attribute for this item
            const itemRow = document.querySelector(`tr[data-item-id="${itemId}"]`);
            if (itemRow) {
              itemRow.setAttribute('data-shipping-details', JSON.stringify(shippingDetails));
            }
          }

          console.log("Updated cached shipping data:", cachedShippingData);

          // Clear popupCloseMessage for this item since update was successful
          updateDetailsResponse?.[itemId] && delete updateDetailsResponse[itemId];

          // Clear original data since update was successful
          if (itemId && originalShippingData[itemId]) {
            delete originalShippingData[itemId];
          }
          delete originalShippingData.itemId;

          // Close the popup by removing the backdrop and popup
          const backdrop = button.closest('.backdrop1');
          if (backdrop) {
            backdrop.remove();
          } else {
            // Fallback: try to find and remove popup using jQuery
            $('.popup-autoinvest-shipping-address').closest('.backdrop1').remove();
          }
        }
      });

      req.error(function(err) {
        console.error("Shipping address update error:", err);
      });

      req.call();

    } catch (error) {
      console.error("Update shipping address error:", error);
    }
  }

  function handleCancelAutoInvest(button) {
    console.log("CANCEL-AUTO-INVEST BUTTON Clicked");

    try {
      const container = button.closest(".autoinvest-controls-wrapper");
      const row = container.closest("tr").previousElementSibling;
      const itemId = row.getAttribute("data-item-id");

      const data = {
        autoInvestId: itemId
      };

      console.log("Sending cancel auto-invest data:", data);

      const requestUrl = `${servicesUrl}${url}/cancel-by-autoinvest-id`;

      var req = new Request(requestUrl, data);

      req.afterWarningDialogFunction(function(res) {
        req.send(true);
      })

      req.success(function(result) {
        console.log("Cancel auto-invest successful:", result);

        if (result.allowApplyToAll !== undefined && result.allowApplyToAll !== null) {
          allowApplyToAll = result.allowApplyToAll;
        }

        if (result.id) {
          const dataRow = document.querySelector(`tr[data-item-id="${result.id}"]`);
          const controlsRow = document.querySelector(`#auto-invest-item-${result.id}`);

          if (dataRow) dataRow.remove();
          if (controlsRow) controlsRow.remove();

          if (cachedShippingData[result.id]) {
            delete cachedShippingData[result.id];
          }
          if (forceShipItems[result.id] !== undefined) {
            delete forceShipItems[result.id];
          }

          const remainingItems = document.querySelectorAll('tr[data-item-id]');
          if (remainingItems.length === 0) {
            const noItem = '<tr class="no-item"><td class="padding-side-10 no-border-bot"></td><td class="no-border-bot empty text-left" colspan="6">You currently have no active AutoInvest orders. To get started, simply add your preferred products to your cart as you would for a regular purchase. At checkout, select your desired AutoInvest frequency and confirm your order.</td><td class="padding-side-10 no-border-bot"></td></tr>';
            document.querySelector('.autoinvest-orders-table tbody').innerHTML = noItem;
          }
        }
      });

      req.error(function(err) {
        console.error("Cancel auto-invest error:", err);
      });

      req.call();

    } catch (error) {
      console.error("Cancel auto-invest button error:", error);
    }
  }

  // NEW FUNCTION: Check if shipping data has changed
  function hasShippingDataChanged(popupElement) {
    try {
      const itemId = originalShippingData.itemId;

      if (!itemId || !originalShippingData[itemId]) {
        return false;
      }

      const original = originalShippingData[itemId];

      // Check if radio selection changed
      const useDefaultAddress = $(popupElement).find('#ship-to-same-address').is(':checked');
      console.log("useDefaultAddress:", useDefaultAddress);
      // const useDefaultAddress = popupElement.querySelector('#ship-to-same-address')?.checked;
      const useDifferentAddress = $(popupElement).find('#ship-to-another-address').is(':checked');

      const currentShipToAnother = useDifferentAddress || forceShipToDifferentLocation;

      if (original.shipToAnother !== currentShipToAnother) {
        return true;
      }

      // If using different address, check all fields
      if (currentShipToAnother) {
        const $popup = $(popupElement);

        const currentName = $.trim($popup.find('#shipping-name').val()) || '';
        const currentAddress1 = $.trim($popup.find('#shipping-address1').val()) || '';
        const currentAddress2 = $.trim($popup.find('#shipping-address2').val()) || '';
        const currentCity = $.trim($popup.find('#shipping-city').val()) || '';
        const currentPostCode = $.trim($popup.find('#shipping-post-code').val()) || '';
        const currentCountry = $.trim($popup.find('#shipping-country').val()) || '';

        // Get state value
        let currentState = '';
        const $stateTextField = $popup.find('#shipping-state-textfield');
        const $stateDropdown = $popup.find('#shipping-state');
        const $stateFormSelectField = $popup.find('.state-form-select-field');

        if ($stateFormSelectField.length && !$stateFormSelectField.hasClass('hide') && $stateDropdown.length) {
          currentState = $.trim($stateDropdown.val()) || '';
        } else if ($stateTextField.length) {
          currentState = $.trim($stateTextField.val()) || '';
        }

        // Check apply-to-all checkbox
        const currentApplyToAll = $popup.find('#apply-to-all-orders').is(':checked');

        // Compare with original values
        if (
          currentName !== (original.shippingName || '') ||
          currentAddress1 !== (original.shippingAddress1 || '') ||
          currentAddress2 !== (original.shippingAddress2 || '') ||
          currentCity !== (original.shippingCity || '') ||
          currentPostCode !== (original.shippingPostCode || '') ||
          currentState !== (original.shippingState || '') ||
          currentCountry !== (original.shippingCountryCode || '')
          // || currentApplyToAll !== (original.applyToAllOrders || false)
        ) {
          return true;
        }
      }

      return false;
    } catch (error) {
      console.error("Error checking shipping data changes:", error);
      return false;
    }
  }

  // NEW FUNCTION: Close the shipping popup
  function closeShippingPopup() {
    // Clear original data
    const itemId = originalShippingData.itemId;
    if (itemId && originalShippingData[itemId]) {
      delete originalShippingData[itemId];
    }
    delete originalShippingData.itemId;

    // Remove the popup from DOM
    $('.popup-autoinvest-shipping-address').closest('.backdrop1').remove();
  }

  // NEW FUNCTION: Show notification message with popup
  function showNotification(message, type) {
    // Create backdrop
    const backdrop = document.createElement('div');
    backdrop.className = 'backdrop1';
    backdrop.style.cssText = 'position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); z-index: 9999; display: flex; align-items: center; justify-content: center;';

    // Create popup container
    const popup = document.createElement('div');
    popup.className = 'popup popup-autoinvest-notification';
    popup.style.cssText = 'background: white; border-radius: 8px; padding: 30px; max-width: 400px; width: 90%; box-shadow: 0 4px 20px rgba(0,0,0,0.3); position: relative;';

    // Create title
    const title = document.createElement('h3');
    title.className = 'title';
    title.textContent = 'AutoInvest';
    title.style.cssText = 'margin: 0 0 15px 0; font-size: 20px; font-weight: bold; color: #333;';

    // Create message
    const messageDiv = document.createElement('p');
    messageDiv.textContent = message;
    messageDiv.style.cssText = 'margin: 0 0 20px 0; font-size: 14px; color: #666; line-height: 1.5;';

    // Create OK button
    const okButton = document.createElement('button');
    okButton.className = 'btn-common';
    okButton.textContent = 'OK';
    okButton.style.cssText = 'width: 100%; padding: 10px 20px; border: none; border-radius: 4px; cursor: pointer; font-size: 14px;';

    // OK button click handler
    okButton.onclick = function() {
      backdrop.remove();
    };

    // Assemble popup
    popup.appendChild(title);
    popup.appendChild(messageDiv);
    popup.appendChild(okButton);
    backdrop.appendChild(popup);

    // Add to document
    document.body.appendChild(backdrop);
  }

  // NEW FUNCTION: Store original shipping data
  function storeOriginalShippingData(itemId, shippingDetails) {
    originalShippingData.itemId = itemId;

    originalShippingData[itemId] = {
      shipToAnother: shippingDetails.shipToAnother || false,
      shippingName: shippingDetails.shippingToAnotherAddress?.name || '',
      shippingAddress1: shippingDetails.shippingToAnotherAddress?.address1 || '',
      shippingAddress2: shippingDetails.shippingToAnotherAddress?.address2 || '',
      shippingCity: shippingDetails.shippingToAnotherAddress?.city || '',
      shippingPostCode: shippingDetails.shippingToAnotherAddress?.postCode || '',
      shippingState: shippingDetails.shippingToAnotherAddress?.state || '',
      shippingCountryCode: shippingDetails.shippingToAnotherAddress?.countryCode || '',
      applyToAllOrders: false // Default value for checkbox
    };
  }

  function handleCloseShippingPopup() {
    console.log("handleCloseShippingPopup clicked!!");

    const popupElement = document.querySelector('.popup-autoinvest-shipping-address');
    const itemId = originalShippingData.itemId;

    // Check if this close is triggered by forceUpdateShippingAddress
    const updateResponse = updateDetailsResponse[itemId];

    // Always reset forceShipToDifferentLocation when closing the popup
    forceShipToDifferentLocation = false;

    if (updateResponse && updateResponse.forceUpdateShippingAddress === true) {
      // UPDATE DELIVERY METHOD TO MATCH API RESPONSE
      if (updateResponse.shippingMethodId) {
        const controlsRow = document.querySelector(`#auto-invest-item-${itemId}`);
        if (controlsRow) {
          const deliverySelect = controlsRow.querySelector("select[name='delivery']");
          if (deliverySelect) {
            deliverySelect.value = updateResponse.shippingMethodId;
            console.log("Updated delivery method to:", updateResponse.shippingMethodId);
          }
        }
      }

      // User closed popup without saving — hide the shipping address link
      updateShippingAddressLinkVisibility(itemId, false);

      // Show notification from API response
      if (updateResponse.forceUpdateShippingAddressCancelNotificationMessage) {
        console.log("Showing notification from update-details response");

        var popup = new Popup({
          title: updateResponse.title || 'AutoInvest Update',
          message: updateResponse.forceUpdateShippingAddressCancelNotificationMessage,
          okCallback: function() {
            // Cleanup
            if (itemId && originalShippingData[itemId]) {
              delete originalShippingData[itemId];
            }
            delete originalShippingData.itemId;

            // Clear the stored response
            if (updateDetailsResponse[itemId]) {
              delete updateDetailsResponse[itemId];
            }

            $('.backdrop1').remove();
          }
        });
        popup.render();
      }
    } else {
      // For other cases (manual open), just close without showing popup
      console.log("Closing shipping popup without notification");

      // Cleanup
      if (itemId && originalShippingData[itemId]) {
        delete originalShippingData[itemId];
      }
      delete originalShippingData.itemId;

      // Just close the backdrop
      $('.backdrop1').remove();
    }
  }


  function updateShippingAddressLinkVisibility(itemId, shouldShowShipping) {
    const controlsRow = document.querySelector(`#auto-invest-item-${itemId}`);
    if (controlsRow) {
      const shippingDiv = controlsRow.querySelector('.popup-auto-invest-shipping-address');
      if (shippingDiv) {
        const shippingLink = shippingDiv.querySelector('.autoinvest-shipping-address');

        if (!shippingLink && shouldShowShipping) {
          shippingDiv.innerHTML = `<a href="javascript:void(0)" class="autoinvest-shipping-address">View / Change Shipping Address</a>`;
        } else if (shippingLink && shouldShowShipping) {
          shippingLink.style.display = "inline-block";
        } else if (shippingLink && !shouldShowShipping) {
          shippingLink.style.display = "none";
        }
      }
    }
  }

  /*
    DESC: Load Auto-Invest page. USED IN: /account/autoinvest page
  */
  function loadAutoInvestPage() {
    console.log("INSIDE loadAutoInvestPage");

    var initOptions = {};

    init(initOptions, function(res) {
      console.log("res.success: " + res.success);
      if (!res.success) {
        // Handle error response
        var errorMessage = res.error || 'Failed to load auto-invest data';
        var errorHtml = '<div class="error-state">' +
          '<h3>Error Loading Auto-Invest Orders</h3>' +
          '<p>' + errorMessage + '</p>' +
          '<button onclick="autoInvestOrdersModule.loadAutoInvestPage()" class="btn-retry">Retry</button>' +
          '</div>';
        $('.auto-invest-wrap').html(errorHtml);
        return;
      }

      console.log("res.items: ", res.items);

      // Ensure res has the expected structure
      if (!res.items) {
        res.items = [];
      }

      for (let item of res.items) {
        item.autoInvestFrequencies = res.autoInvestFrequencies || [];

        // Initialize cache with server data
        if (item.id && item.shippingDetails) {
          cachedShippingData[item.id] = item.shippingDetails;
        }
      }

      console.log(res.items);

      // Render the template
      try {
        document.querySelectorAll('.autoinvest-item-settings .select-currency select').forEach(select => {
          select.removeEventListener('change', handleCurrencyChange);
        });

        $('.auto-invest-wrap').html(tmpl($('#tmpl-autoinvest-overview').html(), {
          obj: res
        }));

        document.querySelectorAll('.autoinvest-item-settings .select-currency select').forEach(select => {
          select.addEventListener('change', handleCurrencyChange);
        });

        document.querySelectorAll('.autoinvest-item-settings select[name="payment"]').forEach(select => {
          select.addEventListener('change', handlePaymentChange);
        });
      } catch (templateError) {
        console.error("Template rendering error:", templateError);
        $('.auto-invest-wrap').html('<div class="error-state">Error rendering page. Please refresh and try again.</div>');
        return;
      }

      // Set default visibility and arrow states
      setTimeout(() => {
        const allControlsRows = document.querySelectorAll('[id^="auto-invest-item-"]');
        const allDropDownButtons = document.querySelectorAll('.drop-down-button');

        allControlsRows.forEach((row, index) => {
          if (index === 0) {
            // First record: keep expanded, rotate arrow to indicate expanded state
            row.style.display = '';
            if (allDropDownButtons[index]) {
              allDropDownButtons[index].style.transform = 'rotate(180deg)';
            }
          } else {
            // Other records: hide controls, keep arrow in normal position
            row.style.display = 'none';
            if (allDropDownButtons[index]) {
              allDropDownButtons[index].style.transform = 'rotate(0deg)';
            }
          }
        });
      }, 0);

      checkEmptyAutoInvestOrders(res);

      // Set up all button-event handlers
      buttonActions();

      $('.change-storage-location').on('click', function() {
        var popup = new PopupStorageLocation(res.locations);
        popup.render();
      });
    });


    // Updated shipping address popup handler to use cached data
    $(document).off('click', '.autoinvest-shipping-address').on('click', '.autoinvest-shipping-address', function(e) {
      e.preventDefault();
      const itemRow = $(this).closest('tr').prev('tr[data-item-id]');
      const itemId = itemRow.attr('data-item-id');

      let shippingDetails;
      if (cachedShippingData[itemId]) {
        console.log("Using cached shipping data for item:", itemId);
        shippingDetails = cachedShippingData[itemId];
      } else {
        console.log("Using data attribute for item:", itemId);
        shippingDetails = JSON.parse(itemRow.attr('data-shipping-details') || '{}');
      }

      // Restore per-item forced shipping state before opening popup
      forceShipToDifferentLocation = forceShipItems[itemId] || false;

      var shippingData = {
        ...shippingDetails,
        title: 'Shipping Address',
        itemId: itemId,
        shippingCountries: cachedShippingCountries,
        forceShipToDifferentLocation: forceShipToDifferentLocation,
        locationId: locationId,
        handleCloseShippingPopup: handleCloseShippingPopup,
        allowApplyToAll: allowApplyToAll,
        isAutoOpened: false // indicates manual open
      };

      console.log("Opening shipping popup with data:", shippingData);

      // Store original data before opening popup
      storeOriginalShippingData(itemId, shippingDetails);

      var popupAutoInvestShippingAddress = new PopupAutoInvestShippingAddress(shippingData);
      popupAutoInvestShippingAddress.render();

      if (allowApplyToAll) {
        $('.checkbox-one-line.full-width').removeClass('hide');
      } else {
        $('.checkbox-one-line.full-width').addClass('hide');
      }

      toggleShippingForms();
      const countryCode = shippingData.shippingToAnotherAddress?.countryCode;
      if (countryCode) {
        $('#shipping-country').closest('.with-flag').find('.flag').attr('class', 'flag flag-' + countryCode.toLowerCase());
      }
      countrySelect('#shipping-country');
    });

    $(document).off('change', 'input[name="delivery-shipping"]').on('change', 'input[name="delivery-shipping"]', function() {
      toggleShippingForms();
    });
  }

  function handleCurrencyChange(event) {
    console.log("CURRENCY SELECT Changed " + event.target);

    const row = event.target.closest("tr");
    const itemId = row.getAttribute("data-item-id");
    const currency = event.target.value;
    const frequency = row.querySelector("select[name='frequency']")?.value;
    const paymentMethodId = row.querySelector("select[name='payment']")?.value;
    const shippingMethodId = row.querySelector("select[name='delivery']")?.value;
    var data = {
      id: itemId,
      currency: currency,
      frequencyId: frequency,
      paymentMethodId: paymentMethodId,
      shippingMethodId: shippingMethodId
    };
    console.log("Currency changed data:", data);
    previewDetails(data, function(res) {
      console.log("Preview details response:", res)
      if (res.success) {
        var obj = {
          ...res.item,
          autoInvestFrequencies: res.autoInvestFrequencies || []
        }

        var rowId = '#auto-invest-item-' + itemId;
        document.querySelectorAll(rowId + '.autoinvest-item-settings .select-currency select').forEach(function(select) {
          select.removeEventListener('change', handleCurrencyChange);
        });

        $(rowId).html(tmpl($('#tmpl-autoinvest-item-settings').html(), {
          obj: obj
        }));

        document.querySelectorAll(rowId + '.autoinvest-item-settings .select-currency select').forEach(select => {
          select.addEventListener('change', handleCurrencyChange);
        });

        document.querySelectorAll(rowId + ' select[name="payment"]').forEach(select => {
          select.addEventListener('change', handlePaymentChange);
        });
      } else {
        console.error("Preview details failed:", res);
      }
    });
  }

  function handlePaymentChange(event) {
    console.log("PAYMENT SELECT Changed " + event.target);

    const row = event.target.closest("tr");
    const itemId = row.getAttribute("data-item-id");
    var data = {
      id: itemId,
      currency: row.querySelector("select[name='currency']")?.value,
      frequencyId: row.querySelector("select[name='frequency']")?.value,
      paymentMethodId: event.target.value,
      shippingMethodId: row.querySelector("select[name='delivery']")?.value
    };
    console.log("Payment changed data:", data);
    previewDetailsPayment(data);
  }

  function toggleShippingForms() {
    if ($('#ship-to-another-address').is(':checked')) {
      $('.shipping-forms.form').removeClass('hide');
    } else {
      $('.shipping-forms.form').addClass('hide');
    }
  }


  return {
    init: init,
    loadAutoInvestPage: loadAutoInvestPage,
    checkEmptyAutoInvestOrders: checkEmptyAutoInvestOrders
  };
}());